export type DiscrepancyStatus = 'draft' | 'open' | 'resolved'

export type DiscrepancyType =
  | 'receipt_not_validated'
  | 'count_mismatch'
  | 'location_error'
  | 'lot_serial_error'
  | 'system_vs_physical'
  | 'shipment_short_over'
  | 'shipped_wrong_location'
  | 'incorrect_label'
  | 'incorrect_cofa_info'
  | 'other'

export const DISCREPANCY_TYPE_LABELS: Record<DiscrepancyType, string> = {
  receipt_not_validated: 'Receipt not validated',
  count_mismatch: 'Count mismatch',
  location_error: 'Inventory location error',
  lot_serial_error: 'Lot / serial error',
  system_vs_physical: 'System vs physical mismatch',
  shipment_short_over: 'Shipment short / over',
  shipped_wrong_location: 'Shipped to wrong location',
  incorrect_label: 'Incorrect Product Label',
  incorrect_cofa_info: 'Incorrect CofA/Product Information',
  other: 'Other',
}

export interface TimelineEvent {
  when: string
  event: string
  result: string
}

export interface CorrectiveAction {
  action: string
  owner: string
  due_date: string
}

export interface DiscrepancyReport {
  id: string
  report_number: string
  status: DiscrepancyStatus
  // Report details
  report_date: string | null
  prepared_by: string | null
  prepared_for: string | null
  date_discovered: string | null
  date_of_occurrence: string | null
  days_unresolved: number | null
  facility_site: string | null
  // Discrepancy type
  discrepancy_types: DiscrepancyType[]
  // Reference / shipment
  purchase_order: string | null
  vendor: string | null
  product: string | null
  quantity: string | null
  scheduled_receipt_date: string | null
  odoo_receipt: string | null
  current_record_status: string | null
  po_buyer: string | null
  // Narrative & analysis
  narrative: string | null
  business_impact: string | null
  initial_cause: string | null
  recommended_followup: string | null
  // Repeating
  timeline_events: TimelineEvent[]
  corrective_actions: CorrectiveAction[]
  // Cross-module linkage
  warehouse_incident_id: string | null
  // Meta
  created_by: string | null
  pdf_file_id: string | null
  created_at: string | null
  updated_at: string | null
}

export interface DiscrepancyListResponse {
  items: DiscrepancyReport[]
  total: number
  page: number
  limit: number
}

export interface DiscrepancyStats {
  total: number
  by_status: Record<string, number>
  draft: number
  open: number
  resolved: number
}

export interface GeneratePdfResponse {
  file_id: string
  filename: string
}

export type DiscrepancyWrite = Omit<
  DiscrepancyReport,
  'id' | 'report_number' | 'status' | 'created_by' | 'pdf_file_id' | 'created_at' | 'updated_at'
>
